export const deliverySectionParamsMapper = checkout => {
  var _checkout$appliedDisc, _checkout$shippingInf, _checkout$shippingInf2, _checkout$shippingInf3, _checkout$shippingInf4, _checkout$shippingInf5, _checkout$shippingInf6, _checkout$additionalF, _checkout$shippingInf7, _checkout$calculation, _checkout$shippingInf8, _checkout$shippingInf9, _checkout$shippingInf10, _checkout$shippingInf11, _checkout$violations, _checkout$shippingInf12, _checkout$shippingInf13;
  const appliedCoupon = (_checkout$appliedDisc = checkout.appliedDiscounts) == null || (_checkout$appliedDisc = _checkout$appliedDisc.find(discount => discount.coupon)) == null ? void 0 : _checkout$appliedDisc.coupon;
  const currency = checkout.paymentCurrency;
  const isSiteCurrency = checkout.currency === checkout.conversionCurrency;
  const formattedConvertedAmount = (_checkout$shippingInf = checkout.shippingInfo) == null || (_checkout$shippingInf = _checkout$shippingInf.selectedCarrierServiceOption) == null || (_checkout$shippingInf = _checkout$shippingInf.cost) == null || (_checkout$shippingInf = _checkout$shippingInf.price) == null ? void 0 : _checkout$shippingInf.formattedConvertedAmount;
  const defaultSelectedDeliveryOption = checkout != null && (_checkout$shippingInf2 = checkout.shippingInfo) != null && _checkout$shippingInf2.selectedCarrierServiceOption ? {
    code: (_checkout$shippingInf3 = checkout.shippingInfo) == null || (_checkout$shippingInf3 = _checkout$shippingInf3.selectedCarrierServiceOption) == null ? void 0 : _checkout$shippingInf3.code,
    logistics: (_checkout$shippingInf4 = checkout.shippingInfo) == null || (_checkout$shippingInf4 = _checkout$shippingInf4.selectedCarrierServiceOption) == null ? void 0 : _checkout$shippingInf4.logistics,
    title: (_checkout$shippingInf5 = checkout.shippingInfo) == null || (_checkout$shippingInf5 = _checkout$shippingInf5.selectedCarrierServiceOption) == null ? void 0 : _checkout$shippingInf5.title,
    cost: {
      deliveryPrice: {
        convertedAmount: (_checkout$shippingInf6 = checkout.shippingInfo) == null || (_checkout$shippingInf6 = _checkout$shippingInf6.selectedCarrierServiceOption) == null || (_checkout$shippingInf6 = _checkout$shippingInf6.cost) == null || (_checkout$shippingInf6 = _checkout$shippingInf6.price) == null ? void 0 : _checkout$shippingInf6.amount,
        formattedConvertedAmount
      },
      totalPrice: {
        formattedConvertedAmount
      },
      additionalCosts: (_checkout$additionalF = checkout.additionalFees) == null ? void 0 : _checkout$additionalF.map(fee => {
        var _fee$price, _fee$price2;
        return {
          deliveryPrice: {
            convertedAmount: (_fee$price = fee.price) == null ? void 0 : _fee$price.convertedAmount,
            formattedConvertedAmount: (_fee$price2 = fee.price) == null ? void 0 : _fee$price2.formattedConvertedAmount
          }
        };
      }),
      currency
    }
  } : undefined;
  const fallbackDeliverySolutions = carrierServiceOptionsMapper(checkout == null || (_checkout$shippingInf7 = checkout.shippingInfo) == null ? void 0 : _checkout$shippingInf7.carrierServiceOptions, checkout.paymentCurrency);
  const fallbackDeliverySolutionsErrors = (_checkout$calculation = checkout.calculationErrors) == null || (_checkout$calculation = _checkout$calculation.carrierErrors) == null || (_checkout$calculation = _checkout$calculation.errors) == null ? void 0 : _checkout$calculation.map(error => ({
    ...error,
    appId: error.carrierId
  }));
  const lineItems = lineItemsMapper(checkout.lineItems);
  const contactDetails = contactDetailsMapper((_checkout$shippingInf8 = checkout.shippingInfo) == null || (_checkout$shippingInf8 = _checkout$shippingInf8.shippingDestination) == null ? void 0 : _checkout$shippingInf8.contactDetails);
  const destination = (_checkout$shippingInf9 = checkout.shippingInfo) != null && (_checkout$shippingInf9 = _checkout$shippingInf9.shippingDestination) != null && _checkout$shippingInf9.address ? {
    ...((_checkout$shippingInf10 = checkout.shippingInfo) == null || (_checkout$shippingInf10 = _checkout$shippingInf10.shippingDestination) == null ? void 0 : _checkout$shippingInf10.address),
    addressLine: (_checkout$shippingInf11 = checkout.shippingInfo) == null || (_checkout$shippingInf11 = _checkout$shippingInf11.shippingDestination) == null || (_checkout$shippingInf11 = _checkout$shippingInf11.address) == null ? void 0 : _checkout$shippingInf11.addressLine1
  } : {};
  const violations = (_checkout$violations = checkout.violations) == null || (_checkout$violations = _checkout$violations.filter(violation => {
    var _violation$target;
    return (violation == null || (_violation$target = violation.target) == null || (_violation$target = _violation$target.other) == null ? void 0 : _violation$target.name) === 'DELIVERY' && !!violation.description;
  })) == null ? void 0 : _checkout$violations.map(violation => violation.description);
  return {
    currency,
    isSiteCurrency,
    destination,
    lineItems,
    contactDetails,
    purchaseFlowId: checkout.purchaseFlowId,
    userPreferences: [{
      appId: (_checkout$shippingInf12 = checkout.shippingInfo) == null || (_checkout$shippingInf12 = _checkout$shippingInf12.selectedCarrierServiceOption) == null ? void 0 : _checkout$shippingInf12.carrierId,
      code: (_checkout$shippingInf13 = checkout.shippingInfo) == null || (_checkout$shippingInf13 = _checkout$shippingInf13.selectedCarrierServiceOption) == null ? void 0 : _checkout$shippingInf13.code
    }],
    appliedCouponType: appliedCoupon == null ? void 0 : appliedCoupon.couponType,
    defaultSelectedDeliveryOption,
    fallbackDeliveryOptions: {
      deliverySolutions: fallbackDeliverySolutions,
      errors: fallbackDeliverySolutionsErrors
    },
    violations,
    weightUnit: checkout.weightUnit,
    checkoutInfo: {
      checkoutUpdatedDate: checkout._updatedDate || checkout.updatedDate,
      checkoutId: checkout._id
    }
  };
};
const subscriptionSettingsMapper = subscriptionSettings => {
  if (!subscriptionSettings) {
    return undefined;
  }
  return {
    frequency: subscriptionSettings == null ? void 0 : subscriptionSettings.frequency,
    interval: subscriptionSettings == null ? void 0 : subscriptionSettings.interval,
    freeTrial: !!(subscriptionSettings != null && subscriptionSettings.freeTrialPeriod)
  };
};
export const lineItemsMapper = lineItems => {
  if (lineItems === undefined) {
    return [];
  }
  return lineItems.map(lineItem => {
    var _lineItem$price, _lineItem$productName, _lineItem$priceBefore, _lineItem$totalPriceB, _lineItem$totalPriceB2, _lineItem$subscriptio;
    return {
      id: lineItem._id,
      price: (_lineItem$price = lineItem.price) == null ? void 0 : _lineItem$price.amount,
      quantity: lineItem.quantity,
      catalogReference: lineItem.catalogReference,
      deliveryProfileId: lineItem.deliveryProfileId,
      name: (_lineItem$productName = lineItem.productName) == null ? void 0 : _lineItem$productName.original,
      physicalProperties: lineItem.physicalProperties,
      priceBeforeDiscount: (_lineItem$priceBefore = lineItem.priceBeforeDiscounts) == null ? void 0 : _lineItem$priceBefore.amount,
      totalPriceBeforeDiscount: (_lineItem$totalPriceB = lineItem.totalPriceBeforeTax) == null ? void 0 : _lineItem$totalPriceB.amount,
      totalPrice: (_lineItem$totalPriceB2 = lineItem.totalPriceBeforeTax) == null ? void 0 : _lineItem$totalPriceB2.amount,
      subscriptionSettings: subscriptionSettingsMapper((_lineItem$subscriptio = lineItem.subscriptionOptionInfo) == null ? void 0 : _lineItem$subscriptio.subscriptionSettings)
    };
  });
};
export const contactDetailsMapper = contactDetails => {
  const result = {
    company: contactDetails == null ? void 0 : contactDetails.company,
    firstName: contactDetails == null ? void 0 : contactDetails.firstName,
    lastName: contactDetails == null ? void 0 : contactDetails.lastName,
    phone: contactDetails == null ? void 0 : contactDetails.phone
  };
  if (contactDetails != null && contactDetails.vatId) {
    return {
      ...result,
      vatId: {
        id: contactDetails.vatId._id,
        type: contactDetails.vatId.type
      }
    };
  }
  return result;
};
export const carrierServiceOptionsMapper = (carrierServiceOption, currency) => {
  const fallbackDeliveryOptions = carrierServiceOption == null ? void 0 : carrierServiceOption.flatMap(carrierService => {
    var _carrierService$shipp;
    return carrierService == null || (_carrierService$shipp = carrierService.shippingOptions) == null ? void 0 : _carrierService$shipp.map(shippingOption => {
      var _shippingOption$cost, _shippingOption$cost2, _shippingOption$cost3;
      return {
        code: shippingOption.code,
        title: shippingOption.title,
        cost: {
          deliveryPrice: {
            convertedAmount: (_shippingOption$cost = shippingOption.cost) == null || (_shippingOption$cost = _shippingOption$cost.price) == null ? void 0 : _shippingOption$cost.amount,
            formattedConvertedAmount: (_shippingOption$cost2 = shippingOption.cost) == null || (_shippingOption$cost2 = _shippingOption$cost2.price) == null ? void 0 : _shippingOption$cost2.formattedConvertedAmount
          },
          totalPrice: {
            formattedConvertedAmount: (_shippingOption$cost3 = shippingOption.cost) == null || (_shippingOption$cost3 = _shippingOption$cost3.price) == null ? void 0 : _shippingOption$cost3.formattedConvertedAmount
          },
          currency
        },
        logistics: shippingOption.logistics,
        deliveryAllocations: shippingOption.deliveryAllocations ?? [{
          deliveryCarrier: {
            appId: carrierService.carrierId
          }
        }],
        partial: shippingOption.partial
      };
    });
  });
  const filteredFallbackDeliveryOptions = fallbackDeliveryOptions == null ? void 0 : fallbackDeliveryOptions.filter(shippingOptions => !!shippingOptions);
  return filteredFallbackDeliveryOptions;
};
export const deliveryOptionsMapper = mappedDeliveryOptions => {
  var _deliveries$deliveryM, _deliveries$pickupMet;
  const deliveries = mappedDeliveryOptions == null ? void 0 : mappedDeliveryOptions.deliveries;
  if (!deliveries) {
    return mappedDeliveryOptions;
  }
  return {
    ...mappedDeliveryOptions,
    deliveries: {
      deliveryMethods: (_deliveries$deliveryM = deliveries.deliveryMethods) == null ? void 0 : _deliveries$deliveryM.map(mapSubtitle),
      pickupMethods: (_deliveries$pickupMet = deliveries.pickupMethods) == null ? void 0 : _deliveries$pickupMet.map(mapSubtitle)
    }
  };
};
const mapSubtitle = option => {
  const subOption = option.options[0];
  const baseSubtitle = (subOption == null ? void 0 : subOption.deliveryTime) || (option == null ? void 0 : option.subtitle) || '';
  const subtitle = [baseSubtitle, option.additionalFeeSubtitle].filter(Boolean).join(' | ');
  return {
    ...option,
    subtitle,
    additionalFeeSubtitle: undefined
  };
};
//# sourceMappingURL=mappers.js.map